document.addEventListener("DOMContentLoaded", function() {
  const firstChanger = document.querySelector(".first-grid-changer");
  const secondChanger = document.querySelector(".second-grid-changer");

  if (!firstChanger || !secondChanger) {
    console.warn("Grid changer buttons not found");
    return;
  }

  firstChanger.addEventListener("click", function () {
    console.log("First clicked");
    this.classList.add("active");
    secondChanger.classList.remove("active");

    document.querySelectorAll("#product-grid.product-grid").forEach(el => {
      el.classList.add("grid--1-col-tablet-down");
      el.classList.remove("grid--2-col-tablet-down");
    });
  });

  secondChanger.addEventListener("click", function () {
    console.log("Second clicked");
    this.classList.add("active");
    firstChanger.classList.remove("active");

    document.querySelectorAll("#product-grid.product-grid").forEach(el => {
      el.classList.remove("grid--1-col-tablet-down");
      el.classList.add("grid--2-col-tablet-down");
    });
  });
});


// Custom Flow


document.addEventListener('DOMContentLoaded', function () {
  const sizeOptions = document.querySelector('.custom-size-options');
  const styleOptions = document.querySelector('.custom-addon-options');
  const hiddenSizeInput = document.getElementById('hidden_size_input');
  const hiddenStyleInput = document.getElementById('hidden_style_input');

  // Helper functions
  function clearFields(wrapper) {
    if (!wrapper) return;
    const inputs = wrapper.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.checked = false;
      input.disabled = true;
    });
  }

  function enableFields(wrapper) {
    if (!wrapper) return;
    const inputs = wrapper.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.disabled = false;
    });
  }

  function selectFirstChecked(wrapper, hiddenInput) {
    if (!wrapper) return;
    const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      hiddenInput.value = checkedRadio.value;
    } else {
      const firstRadio = wrapper.querySelector('input[type="radio"]:not(:disabled)');
      if (firstRadio) {
        firstRadio.checked = true;
        hiddenInput.value = firstRadio.value;
      }
    }
  }

  // Update hidden input when a radio changes
  function updateHiddenInputs() {
    const selectedSize = sizeOptions?.querySelector('input[type="radio"]:checked');
    const selectedStyle = styleOptions?.querySelector('input[type="radio"]:checked');

    if (hiddenSizeInput) hiddenSizeInput.value = selectedSize ? selectedSize.value : '';
    if (hiddenStyleInput) hiddenStyleInput.value = selectedStyle ? selectedStyle.value : '';
  }

  // Show/hide logic based on "Type" selection
  function updateOptionVisibility() {
    const selectedVariant = document.querySelector('input[type="radio"][name^="Type"]:checked');
    if (!selectedVariant) return;

    const typeValue = selectedVariant.value.trim().toLowerCase();

    if (typeValue === 'unstitched') {
      if (sizeOptions) {
        sizeOptions.style.display = 'none';
        clearFields(sizeOptions);
      }
      if (styleOptions) {
        styleOptions.style.display = 'none';
        clearFields(styleOptions);
      }
      hiddenSizeInput.value = '';
      hiddenStyleInput.value = '';
    } else {
      if (sizeOptions) {
        sizeOptions.style.display = 'block';
        enableFields(sizeOptions);
        selectFirstChecked(sizeOptions, hiddenSizeInput);
      }
      if (styleOptions) {
        styleOptions.style.display = 'block';
        enableFields(styleOptions);
        selectFirstChecked(styleOptions, hiddenStyleInput);
      }
    }
  }

  // Initial run
  updateOptionVisibility();

  // Event listeners
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('input[type="radio"][name^="Type"]')) {
      setTimeout(updateOptionVisibility, 50);
    }

    if (e.target.closest('.custom-size-options input[type="radio"], .custom-addon-options input[type="radio"]')) {
      setTimeout(updateHiddenInputs, 50);
    }
  });
});


